import { render, staticRenderFns } from "./BooleanField.vue?vue&type=template&id=a864cb20&lang=pug&"
import script from "./BooleanField.vue?vue&type=script&lang=js&"
export * from "./BooleanField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a864cb20')) {
      api.createRecord('a864cb20', component.options)
    } else {
      api.reload('a864cb20', component.options)
    }
    module.hot.accept("./BooleanField.vue?vue&type=template&id=a864cb20&lang=pug&", function () {
      api.rerender('a864cb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/BooleanField.vue"
export default component.exports